import React from 'react'
import ActionCard from '~/components/features/cards/actionCard'

const Actions = (props) => {
  const { title, actionsInformations } = props.data

  return (
    <div className="fluid-grid">
      <div className="row pb-16 md:pb-20">
        <div className="col-12 lg-col-10 xl-col-8 mx-auto">
          <div className="xl-col-6 mx-auto">
            {title && <h2 className="title-2-bold text-center">{title}</h2>}
          </div>

          <div className="newsroom-list">
            {actionsInformations.map((action, i) => {
              return (
                <div
                  className="my-8 newsroom-list__action flex w-full"
                  key={action.title}
                >
                  <ActionCard action={action} />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Actions
